export enum DefaultWarehouseStep {
  Name = 'name',
  Perimeter = 'perimeter',
  Angle = 'angle',
  Entry = 'entry',
  Type = 'type',
}

export enum FixedWarehouseStep {
  Name = 'name',
  Coordinates = 'coordinates',
}
